import React, { useState, useEffect, useCallback } from 'react';
import { talukaAPI } from '../../services/api';

export default function TalukaFacilities() {
  const [items, setItems]   = useState([]);
  const [gps, setGps]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]   = useState(null);
  const [page, setPage]     = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({ tenant_id: '', type: '', search: '' });

  const load = useCallback(async () => {
    try {
      setLoading(true); setError(null);
      const [fRes, gRes] = await Promise.all([
        talukaAPI.getFacilities({ page, limit: 20, ...filters }),
        gps.length === 0 ? talukaAPI.getGrampanchayats() : Promise.resolve({ data: { grampanchayats: gps } })
      ]);
      const d = fRes.data?.facilities || fRes.data?.data || fRes.data || {};
      setItems(Array.isArray(d) ? d : []);
      setTotalPages(fRes.data?.pagination?.totalPages || Math.ceil((fRes.data?.pagination?.total || 1) / 20) || 1);
      if (gps.length === 0) setGps(gRes.data?.grampanchayats || gRes.data?.data || gRes.data || []);
    } catch (e) {
      setError(e.response?.data?.message || 'Failed to load facilities');
    } finally { setLoading(false); }
  }, [page, filters]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { load(); }, [load]);
  const setF = (key, val) => { setFilters(f => ({ ...f, [key]: val })); setPage(1); };

  return (
    <div>
      <div className="tk-page-header">
        <h1>Facilities</h1>
        <p>Public facilities and infrastructure across Grampanchayats</p>
      </div>
      <div className="tk-filter-bar">
        <input placeholder="Search facility name…" value={filters.search} onChange={e => setF('search', e.target.value)} />
        <select value={filters.tenant_id} onChange={e => setF('tenant_id', e.target.value)}>
          <option value="">All GPs</option>
          {gps.map(g => <option key={g.id} value={g.id}>{g.name}</option>)}
        </select>
        <select value={filters.type} onChange={e => setF('type', e.target.value)}>
          <option value="">All Types</option>
          <option value="school">School</option>
          <option value="hospital">Hospital</option>
          <option value="water">Water Supply</option>
          <option value="road">Road</option>
          <option value="community_hall">Community Hall</option>
          <option value="other">Other</option>
        </select>
      </div>
      {loading && <div style={{ textAlign: 'center', padding: 40 }}>Loading…</div>}
      {error   && <div style={{ textAlign: 'center', padding: 40, color: '#c62828' }}>{error}</div>}
      {!loading && !error && (
        <>
          <div className="tk-card">
            <div className="tk-table-wrap">
              <table className="tk-table">
                <thead>
                  <tr><th>Name</th><th>Type</th><th>Location</th><th>Grampanchayat</th><th>Status</th><th>Added</th></tr>
                </thead>
                <tbody>
                  {items.map((f, i) => (
                    <tr key={f.id || i}>
                      <td><strong>{f.name}</strong></td>
                      <td style={{ textTransform: 'capitalize' }}>{(f.facility_type || f.type || '—').replace('_', ' ')}</td>
                      <td>{f.location || f.address || '—'}</td>
                      <td>{f.gp_name || f.Tenant?.name || '—'}</td>
                      <td><span className={`tk-badge ${f.is_active ? 'tk-badge-active' : 'tk-badge-inactive'}`}>{f.is_active ? 'Active' : 'Inactive'}</span></td>
                      <td style={{ whiteSpace: 'nowrap' }}>{f.createdAt ? new Date(f.createdAt).toLocaleDateString('en-IN') : '—'}</td>
                    </tr>
                  ))}
                  {items.length === 0 && <tr><td colSpan={6} style={{ textAlign: 'center', padding: 24, color: '#aaa' }}>No facilities found</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
          <div className="tk-pagination">
            <button onClick={() => setPage(p => p - 1)} disabled={page <= 1}>← Prev</button>
            <span style={{ fontSize: '0.85rem', color: '#555' }}>Page {page} of {totalPages}</span>
            <button onClick={() => setPage(p => p + 1)} disabled={page >= totalPages}>Next →</button>
          </div>
        </>
      )}
    </div>
  );
}
